//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The status of a batch */
export const BatchStatus = {
    /**
     * Pending
     * In the process of scanning the checks to it
     */
    Pending: 0,

    /**
     * Open
     * Transactions are all entered and are ready to be matched
     */
    Open: 1,

    /**
     * Closed
     * All is well and good
     */
    Closed: 2
} as const;

/** The status of a batch */
export const BatchStatusDescription: Record<number, string> = {
    0: "Pending",

    1: "Open",

    2: "Closed"
};

/** The status of a batch */
export type BatchStatus = typeof BatchStatus[keyof typeof BatchStatus];
